export default "__VITE_ASSET__Bihp_2el__"